module.exports = __webpack_public_path__ + "img/pie_chart.07cf8064.svg";